import React from "react";
import { Container } from "@material-ui/core";
import "react-awesome-slider/dist/styles.css";
import HeaderComponent from "../../WebSite/Header/HeaderComponent";
import FooterComponent from "../../WebSite/Footer/FooterComponent";
import "../App.css";
import SolutionEcosystem from "../SolutionEcosystem/SolutionEcosystem";
import UpdatesBanner from "../../UpdatesBanner/UpdatesBanner";
import CTA from "../../CTA/CTA";
import ForFarmerChallenges from "../ForFarmerChallenges/ForFarmerChallenges";
// Main component for Home Page
export default class GBRCareLandingPage extends React.Component {
  render() {
    return (
      <>
        {/* Header section */}
        <HeaderComponent />
        {/* Banner section */}

        <UpdatesBanner
          DlBtn="true"
          dlLink="https://play.google.com/store/apps/details?id=com.gbrapp.cbnapp"
          DownloadText="Download App"
          className="farmUpdateBanner"
          bannerTitle="Grow Big & Reap from your Farms"
          bannerbodycopy1={["Join GBR Care to access loan to buy inputs"]}
          href="/auth/3/signup"
          buttonText="Explore"
          clicked={() => {
            localStorage.setItem("userType", "Farmer");
          }}
        />
        {/* Challenges section */}

        <div className="main-wrapper2">
          <ForFarmerChallenges />
        </div>
        {/* Section displaying ecosystem */}
        <SolutionEcosystem
          type="AB"
          bodycopy="System and Process where farmers can have easy access for quality inputs and to make profitable sales."
        />

        {/* Section displaying Call to action */}
        <Container>
          <div className="subSectionWrapper">
            <CTA
              onClick={() => {
                localStorage.setItem("userType", "Farmer");
              }}
              href="/auth/3/signup"
              heading="Unlock hassle-free local trading opportunities by joining community clubs tailored for farmers"
              btnText="Sign Up"
            />
          </div>
        </Container>
        {/* Footer Section */}
        <FooterComponent />
      </>
    );
  }
}
